<template>
    <TableLayout :permissions="['bus:producttype:query']">
      <!-- 搜索表单 -->
      <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
        <el-form-item label="类型名称" prop="productTypeName">
          <el-input v-model="searchForm.productTypeName" placeholder="请输入类型名称" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <section>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </section>
      </el-form>
      <!-- 表格和分页 -->
      <template v-slot:table-wrap>
        <ul class="toolbar" v-permissions="['bus:producttype:create', 'bus:producttype:delete']">
          <li><el-button type="primary" @click="$refs.operaProductTypeWindow.open('新建分类')" icon="el-icon-plus" v-permissions="['bus:producttype:create']">新建</el-button></li>
          <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['bus:producttype:delete']">删除</el-button></li>
        </ul>
        <el-table
          v-loading="isWorking.search"
          :data="tableData.list"
          stripe
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="productTypeName" label="类型名称" min-width="100px"></el-table-column>
          <el-table-column prop="createUser" label="创建人" min-width="100px"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="100px"></el-table-column>
          <!-- <el-table-column prop="updateUser" label="更新人" min-width="100px"></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" min-width="100px"></el-table-column> -->
          <el-table-column
            v-if="containPermissions(['bus:producttype:update', 'bus:producttype:delete'])"
            label="操作"
            min-width="120"
            fixed="right"
          >
            <template slot-scope="{row}">
              <el-button type="text" @click="$refs.operaProductTypeWindow.open('编辑分类', row)" icon="el-icon-edit" v-permissions="['bus:producttype:update']">编辑</el-button>
              <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['bus:producttype:delete']">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :pagination="tableData.pagination"
        >
        </pagination>
      </template>
      <!-- 新建/修改 -->
      <OperaProductTypeWindow ref="operaProductTypeWindow" @success="handlePageChange"/>
    </TableLayout>
  </template>
  
  <script>
  import BaseTable from '@/components/base/BaseTable'
  import TableLayout from '@/layouts/TableLayout'
  import Pagination from '@/components/common/Pagination'
  import OperaProductTypeWindow from '@/components/BUS/OperaProductTypeWindow'
  export default {
    name: 'ProductType',
    extends: BaseTable,
    components: { TableLayout, Pagination, OperaProductTypeWindow },
    data () {
      return {
        // 搜索
        searchForm: {
          productTypeName: ''
        }
      }
    },
    created () {
      this.config({
        module: '',
        api: '/BUS/productType',
        'field.id': 'id',
        'field.main': 'id'
      })
      this.search()
    }
  }
  </script>
  